import React from 'react';
import { observer } from 'mobx-react';

// Translations
import translate from '../Translate.js';

// Dependencies
import Textarea from 'react-textarea-autosize';

const EditExamNotes = observer(class EditExamNotes extends React.Component {
  componentWillMount() {
    const { exam, customConfiguration, enrollmentConfig } = this.props;

    if(enrollmentConfig) {
      if(this.props.configuration) {
        this.state = {
          configuration: this.props.configuration
        }
      } else {
        this.state = {
          configuration: {}
        }
      }
    } else {
      if(typeof exam !== 'undefined' && exam.sid && !customConfiguration) {
        this.state = {
          configuration: exam.configuration
        }
      } else if(customConfiguration) {
        this.state = {
          configuration: customConfiguration
        }
      } else {
        this.state = {
          configuration: exam.configuration
        }
      }
    }
  }

  render() {
    const { automatedOnly, translation } = this.props;

    return(
      <fieldset id="notes">
        <ul className="fields">
          <li className={this.props.defaultDiff('studentNotes')}>
            <label htmlFor="exam-student-notes" aria-describedby="student-notes-tooltip">
              {translation.for_students.label}
              <div className="tooltip">
                <span className="tooltip__label" role="presentation" aria-hidden="true">(?)</span>
                <div id="student-notes-tooltip" className="tooltip__body" role="tooltip">{translation.for_students.tooltip}</div>
              </div>
            </label>

            <Textarea
              id="exam-student-notes"
              className="textarea-grow"
              placeholder={translation.for_students.helper}
              defaultValue={this.state.configuration.studentNotes}
              onChange={(e) => {this.props.handleInput('studentNotes', e, true)}}
              autoFocus
              disabled={this.props.readonly ? true : false}
            ></Textarea>

            {this.props.renderDefault('configuration.studentNotes')}
          </li>

          {!automatedOnly &&
            <li className={this.props.defaultDiff('proctorNotes')}>
              <label htmlFor="exam-proctor-notes" aria-describedby="proctor-notes-tooltip">
                {translation.for_proctors.label}
                <div className="tooltip">
                  <span className="tooltip__label" role="presentation" aria-hidden="true">(?)</span>
                  <div id="proctor-notes-tooltip" className="tooltip__body" role="tooltip">{translation.for_proctors.tooltip}</div>
                </div>
              </label>

              <Textarea
                id="exam-proctor-notes"
                className="textarea-grow"
                placeholder={translation.for_proctors.helper}
                defaultValue={this.state.configuration.proctorNotes}
                onChange={(e) => {this.props.handleInput('proctorNotes', e, true)}}
                disabled={this.props.readonly ? true : false}
              ></Textarea>

              {this.props.renderDefault('configuration.proctorNotes')}
            </li>
          }
        </ul>
      </fieldset>
    );
  }
})

export default translate('EditExamNotes')(EditExamNotes);



// WEBPACK FOOTER //
// ./src/app/components/ExamEdit/EditExamNotes.js